import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'

export const MYHOUSE_ERROR_CODE = {
  REGISTER_DUPLICATED_HOUSE: 'errorCode.duplicatedMyHouse',
}

enum LAND_DENIED_TYPE {
  COMMON,
  BBS_LOAD_FAIL,
  BBS_NOT_INCLUDE_COMPLEX_NO,
  BBS_NOT_AUTH_COMPLEX,
  BBS_NOT_AUTH_READABLE,
  AUTH_LOAD_FAIL,
  AUTH_PROGRESS,
  AUTH_DONE,
  AUTH_MAX_COUNT_OVER,
  AUTH_APPLY_FAIL,
  NOT_LOGIN,
  NOT_PENALTY,
}

const LAND_DENIED_URL = {
  [LAND_DENIED_TYPE.COMMON]: LAND_SERVICE_PREFIX_URL.MYHOUSE_DENIED,
  [LAND_DENIED_TYPE.BBS_LOAD_FAIL]: `${LAND_SERVICE_PREFIX_URL.MYHOUSE_DENIED}/bbs/sequence`,
} as { [key: string]: string }

const getDeniedPath = (deniedType: LAND_DENIED_TYPE) => {
  return LAND_DENIED_URL?.[deniedType] || LAND_DENIED_URL[LAND_DENIED_TYPE.COMMON]
}

export { LAND_DENIED_TYPE, getDeniedPath }
